import { Injectable } from '@angular/core'
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { LoginService } from '../services/login.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private loginService: LoginService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.loginService.loggedIn()) {
      //
      return true
    } else {
      this.router.navigate(['/login'])
      return false
    }
  }
}
